<template lang="pug">
  v-layout(row wrap)
    v-flex(xs12)
      Navbar
    responsive-flex
      v-layout(
        row wrap
        v-if="lender.id === 'greensky'"
        :class="responsiveStyles"
        class="disclosure-div text-xs-left"
      )

        h1 Account Opening and Other Important Disclosures 
      
        v-card.scroll(
            height="225px"
        )
          v-flex.pa-2(
            xs12
            v-html="this.greenskyLegalContent.installmentAccountOpeningDisclosure"
          )
        v-flex(xs12 class="my-3")
          strong {{ this.greenskyLegalContent.electronicConsentTitle }}
        v-flex(xs12 class="mb-2")
          //TODO deprecate the need for if and else consent-checkboxes. one should be enough
          consent-checkbox(
            v-if="hasCoapplicant"
            :hasCoapplicant="true"
            @boxChecked="checkBox('electronicAccepted')"
            @coapplicantChecked="checkBox('electronicAcceptedCoapplicant')"
            :accepted="electronicAccepted"
            :coapplicantAccepted="electronicAcceptedCoapplicant"
            :text="this.greenskyLegalContent.disclosureAcceptAppCoapp"
          )
          consent-checkbox(
            v-else
            @boxChecked="checkBox('electronicAccepted')"
            :accepted="electronicAccepted"
            :text="this.greenskyLegalContent.disclosureAcceptApp"
          )
        v-flex(xs12 class="my-3")
          strong {{ this.greenskyLegalContent.consentSubmitTitle }}
        v-flex(xs12 class="mb-2")
          //TODO deprecate the need for if and else consent-checkboxes. one should be enough
          consent-checkbox(
            v-if="hasCoapplicant"
            :hasCoapplicant="true"
            @boxChecked="checkBox('submitAccepted')"
            @coapplicantChecked="checkBox('submitAcceptedCoapplicant')"
            :accepted="submitAccepted"
            :coapplicantAccepted="submitAcceptedCoapplicant"
            :text="this.greenskyLegalContent.submitAppCoapp"
          )
          consent-checkbox(
            v-else
            @boxChecked="checkBox('submitAccepted')"
            :accepted="submitAccepted"
            :text="this.greenskyLegalContent.submitApp"
          )
        v-flex( v-show="!greenskyPreQual" xs12 class="mb-3") {{ accurateConsent }}
      fortiva-consents(
        v-else-if="lender.id === 'fortiva'"
        @acceptanceChange="setAccepted"
      )
      v-flex(
        xs12 class="subheading red--text"
        v-if="checkForError && !accepted"
      ) Accept terms to continue
      div.xs12.ma-3
        v-alert(
          outline
          :color="'info'"
          :value="true"
        ) {{ alertText }}
      AppNextButton(
        :buttonFunction="finishApplication"
        :disabled="!accepted"
      )
        v-icon(class="mr-2 subheading") lock
        | Submit Application
      v-flex.xs12(
        v-if="lender.id === 'greensky'"
        class="px-3 pt-2 text-xs-left caption"
      )
        div(
          class="full-width"
          v-html="greenskyMainFooter"
        )
    ConsentStatementsGreenskyModal(:greenskyLegalContent="this.greenskyLegalContent" :hasCoapplicant="hasCoapplicant" :showModal="showModal" :setElectronicAccepted="setElectronicAccepted")
</template>

<script>
  import AppNextButton from 'Components/AppNextButton.vue'
  import Navbar from 'Components/Navbar.vue'
  import ConsentCheckbox from 'Components/ConsentCheckbox.vue'
  import { greensky, greenskyLegal } from 'Helpers/lenders'
  import { ageDisclaimer } from 'Helpers/CreditApplicationFormHelper.js'
  import { mapState, mapActions } from 'vuex'
  import ResponsiveFlex from 'Components/ResponsiveFlex.vue'
  import { greenskyFooter } from 'Helpers/CreditApplicationFormHelper.js'
  import FortivaConsents from 'Components/ConsentStatementsFortiva.vue'
  import ConsentStatementsGreenskyModal from '../components/ConsentStatementsGreenskyModal.vue'

  import MarkdownIt from 'markdown-it'
  const md = new MarkdownIt({ html: true })

  export default {
    name: 'consent-statements',
    components: {
      AppNextButton,
      Navbar,
      ConsentCheckbox,
      FortivaConsents,
      ResponsiveFlex,
      ConsentStatementsGreenskyModal
    },
    data () {
      return {
        ageDisclaimer,
        accurateConsent: 'By submitting this Loan Application, you agree that ' +
        'you are applying for any product any financial institution participating ' +
        'in the loan program (each “Lender”) may offer as part of the program '+
        'regardless of any product(s) your merchant, provider, or retailer may ' +
        'have specifically discussed with you.',
        backPath: '/credit-application/review-application',
        checkForError: false,
        greenskyLegalContent: {},
        greensky,
        fortivaAccepted: false,
        electronicAccepted: false,
        submitAccepted: false,
        electronicAcceptedCoapplicant: false,
        submitAcceptedCoapplicant: false,
        greenskyMainFooter: '',
        showModal: false,
      }
    },
    computed: {
      ...mapState({
        lender: state => state.loanApplication.lender,
        customerData: state => state.loanApplication.customerData,
        hasCoapplicant: state => state.loanApplication.hasCoapplicant,
        hasPreQual: state => state.preQualification.hasPreQual,
        preQualificationIdStatusCheck: state => state.preQualification.preQualificationIdStatusCheck,
        greenskyPreQualificationId: state => state.preQualification.greenskyPreQualificationId,
        userData: state => state.user
      }),
      alertText() {
        return this.lender.id === 'greensky' ? 'SUBMITTING APPLICATION WILL IMPACT YOUR CREDIT SCORE' : 'SUBMITTING APPLICATION WILL NOT IMPACT YOUR CREDIT SCORE'
      },
      greenskyPreQual() {
        return this.lender.id === 'greensky' && this.hasPreQual
      },
      accepted() {
        if (this.lender.id === 'greensky') {
          if (this.hasCoapplicant) {
            return this.electronicAccepted && this.submitAccepted &&
              this.electronicAcceptedCoapplicant && this.submitAcceptedCoapplicant
          } else {
            return this.electronicAccepted && this.submitAccepted
          }
        } else if (this.lender.id === 'fortiva') {
          return this.fortivaAccepted
        } else {
          return false
        }
      },
      responsiveStyles () {
        return this.$vuetify.breakpoint.xs ? "mx-3" : "mx-5"
      },
    },
    methods: {
      ...mapActions([
        'submitApplication',
        'saveGreenskyPreQualId',
        'savePreQualId',
        'getGreenskyLegalContent'
      ]),
      checkBox (dataValue) {
        this.$data[dataValue] = !this.$data[dataValue]
      },
      finishApplication () {
        if (this.accepted) {
          this.$router.push({
            path: '/credit-application/status'
          })
          this.submitApplication(this.userData)
        } else {
          this.checkForError = true
        }
      },
      setAccepted () {
        this.fortivaAccepted = !this.fortivaAccepted
      },
      setElectronicAccepted(){
        this.electronicAccepted = true
        if (this.hasCoapplicant) {
          this.electronicAcceptedCoapplicant = true
        }
        this.showModal = false
      }
    },
    async mounted () {
      if (this.lender.id === 'greensky'){
        this.greenskyLegalContent = await this.getGreenskyLegalContent(greenskyLegal)
        this.greenskyMainFooter = await this.getGreenskyLegalContent(greenskyFooter)
        this.showModal = true
      } else {
        this.greenskyLegalContent = greenskyLegal()
        this.greenskyMainFooter = greenskyFooter()
      }
      if (!this.customerData.firstName) {
        console.log("No first name")
        this.$router.push({
          path: '/credit-application/main-form'
        })
      }
      
    },
    beforeDestroy(){
      if(this.preQualificationIdStatusCheck){
        this.savePreQualId(null)
      }
      if(this.greenskyPreQualificationId){
        this.saveGreenskyPreQualId(null)
      }
    }
  }
</script>

<style lang="stylus">
  @import '~vuetify/src/stylus/main'

  .disclosure-div {
    h1 {
      @extend .display-1
      @extend .mt-4
      @extend .mb-3

      line-height: 1.5em !important
    }

    h2 {
      @extend .title
      @extend .mt-4
      @extend .mb-3
    }

    h3 {
      @extend .body-2
      @extend .mt-4
      @extend .mb-3
    }

    li {
      @extend .pb-2
      @extend .ml-3
    }

    p {
      @extend .mb-2
    }
  }
</style>

<style scoped>
  .scroll {
    overflow: scroll;
  }
</style>
